import { createContext, useContext, useState, useEffect } from 'react'

const LanguageContext = createContext()

export const useLanguage = () => {
  const context = useContext(LanguageContext)
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider')
  }
  return context
}

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const savedLanguage = localStorage.getItem('texaconsult-language')
    return savedLanguage || 'fr'
  })

  const languages = {
    fr: { code: 'fr', name: 'Français', flag: '🇫🇷' },
    en: { code: 'en', name: 'English', flag: '🇺🇸' },
    es: { code: 'es', name: 'Español', flag: '🇪🇸' }
  }

  useEffect(() => {
    localStorage.setItem('texaconsult-language', language)
    document.documentElement.lang = language
  }, [language])

  const changeLanguage = (lang) => {
    if (languages[lang]) {
      setLanguage(lang)
    }
  }

  const value = {
    language,
    setLanguage: changeLanguage,
    currentLanguage: languages[language],
    availableLanguages: Object.values(languages) // Ceci retourne un tableau d'objets
  }

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  )
}

export default LanguageContext